import React from "react"
import { connect } from "react-redux"
import QueryString from "query-string"
import { Button } from "reactstrap"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import PackageCollectionForm from "./packageCollectionForm"
import PackageCard from "./packageCard"
import Chips from "components/CommonFilter/chips"
import {
  packageCollectionFilters,
  NO_PERMISSION_MESSAGE,
} from "constants/uiConstants"
import Auxiliary from "../../util/Auxiliary"
import { Divider, Input, Pagination, Tabs, Tag } from "antd"
import { formatNumber } from "../../util/common"
import "../Comment/browseComment.style.css"
import {
  getPackage,
  resetState,
  upsertPackage,
  deletePackage,
  upsertPackageCollection,
} from "../../appRedux/slices/package"

const FILTER_KEYS = [
  {
    key_name: "name",
    display_name: "Name",
  },
  {
    key_name: "packageCollectionId",
    display_name: "Package Collection Id",
  },
]

class ManagePackageCollections extends ErrorBoundComponent {
  state = {
    showModal: false,
    showEntityModal: false,
    filters: {
      pageSize:
        this.props.queryParams && this.props.queryParams["pageSize"]
          ? this.props.queryParams["pageSize"]
          : 10,
      currentPage:
        this.props.queryParams && this.props.queryParams["currentPage"]
          ? this.props.queryParams["currentPage"]
          : 1,
      type:
        this.props.queryParams && this.props.queryParams["type"]
          ? this.props.queryParams["type"]
          : "PACKAGE_COLLECTION",
      name:
        this.props.queryParams && this.props.queryParams["name"]
          ? this.props.queryParams["name"]
          : "",
      packageCollectionId:
        this.props.queryParams && this.props.queryParams["packageCollectionId"]
          ? this.props.queryParams["packageCollectionId"]
          : "",
    },
  }

  componentDidMount() {
    if (!this.props.common.error) {
      let filters = _.clone(this.state.filters)
      this.props.dispatch(getPackage({ filters: _.deepClean(filters) }))
      this.setState({ filters })
      window.addEventListener("keydown", this._keyDownHandler)
    }
  }

  componentDidUpdate() {
    if (this.props.refetch) {
      let filters = _.clone(this.state.filters)
      this.props.dispatch(getPackage({ filters: _.deepClean(filters) }))
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetState())
    window.removeEventListener("keydown", this._keyDownHandler)
  }

  _keyDownHandler = ({ key }) => {
    if (key === "Enter" && this.state.showFilters === true) {
      return this._closeFilters()
    }
    if (key === "Escape" && this.state.showFilters === true) {
      this.setState({
        showFilters: false,
      })
    }
  }

  _onPageChange = value => {
    let newFilters = _.cloneDeep(this.state.filters)
    newFilters["currentPage"] = value
    this.setState({ filters: newFilters }, () => {
      this.props.history.push(
        `/packageCollections/manage?${QueryString.stringify(
          _.deepClean(this.state.filters)
        )}`
      ),
        this.props.dispatch(getPackage({ filters: _.deepClean(newFilters) }))
    })
  }

  _onSubmit = async payload => {
    let type
    type = "package_collection"
    let response
    response = await this.props.dispatch(
      upsertPackageCollection({
        data: payload,
        type,
        action: this.state.action,
      })
    )

    this.setState({ showModal: false, entityData: null })
  }

  _modal = () => {
    return (
      <div className="view_container">
        <PackageCollectionForm
          pageId={this.state.currentPageId}
          type={
            this.props.queryParams && this.props.queryParams.type
              ? this.props.queryParams.type
              : "PACKAGE_COLLECTION"
          }
          onSubmit={this._onSubmit}
          data={this.state.entityData}
          action={this.state.action}
          onCancel={() => this.setState({ showModal: false, entityData: null })}
        />
      </div>
    )
  }

  _showManageCollectionEntities = () => {
    this.props.history.push(
      `/packageCollection/entities/manage?packageCollectionId=${this.state?.entityData?.package_collection_uuid}`
    )
  }

  _onEdit = entityData => {
    // this.setState({ entityData, showEntityModal: true, action: "update" })
    this.setState({ entityData, showModal: true, action: "update" })
  }

  _onCardClick = entityData => {
    this.setState({ entityData, showEntityModal: true, action: "update" })
  }

  _getTitle = () => {
    const type = this.props.queryParams.type
    const typeToLowerCase = type.replace(/_|-|\./g, " ").toLowerCase()
    return (
      <h4>
        {typeToLowerCase.charAt(0).toUpperCase() + typeToLowerCase.slice(1)}
      </h4>
    )
  }

  _handleFilterChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value

    this.setState({
      filters: newFilters,
    })
  }

  _searchCollection = () => {
    let { filters } = this.state
    if (filters && filters.pageSize) {
      delete filters.currentPage
    }
    this.props.history.push(
      `/packageCollections/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    ),
      this.props.dispatch(getPackage({ filters: _.deepClean(filters) }))
  }

  _closeFilters = () => {
    this._searchCollection()
    this.setState({
      showFilters: false,
    })
  }

  _toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  _removeFilter = filter => {
    const newFilters = {
      ...this.state.filters,
      [filter]: packageCollectionFilters[filter].defaultValue,
    }

    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/packageCollections/manage?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
        this.props.dispatch(
          getPackage({ filters: _.deepClean(this.state.filters) })
        )
      }
    )
  }

  _onDelete = entityData => {
    const { package_collection_uuid } = entityData
    const payload = {
      deletedId: package_collection_uuid,
      type: "PACKAGE_COLLECTION",
    }

    this.props.dispatch(deletePackage({ payload }))
    this.props.history.push(
      `/packageCollections/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    )
  }

  _buttons = () => {
    return (
      <div className="d-flex justify-content-end my-2">
        <div className="d-flex">
          <Button
            color="primary"
            className="d-flex"
            onClick={() => {
              if (
                !this.props.currentUser?.permissions?.includes("EDIT_PACKAGE")
              ) {
                toastr.error(NO_PERMISSION_MESSAGE)
                return
              }
              this.setState({ showModal: true, action: "create" })
            }}
          >
            <i className="fa fa-plus mx-1 my-1" />
            Add
          </Button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <Auxiliary
          loading={this.props.loading}
          error={_.get(this.props, "common.error")}
        >
          {!this.state.showModal && (
            <React.Fragment>
              <Chips
                showFilters={this.state.showFilters}
                filters={this.state.filters}
                search={this._closeFilters}
                removeFilter={this._removeFilter}
                handleFilterChange={this._handleFilterChange}
                type="manage_package_collections"
                toggleFilters={this._toggleFilters}
                filterKeys={FILTER_KEYS}
              />
              {this._buttons()}
              {this.props.total &&
                this.props.entityList &&
                this.props.entityList.length > 0 && (
                  <div style={{ textAlign: "center" }} className="mb-2">
                    <Tag color="geekblue">
                      Showing <b>{this.props.entityList.length}</b> of{" "}
                      <b>{formatNumber(this.props.total)}</b> Package
                      Collections
                    </Tag>
                  </div>
                )}
              <div className="discovery-card-container">
                {this.props.entityList &&
                  this.props.entityList.map((entity, i) => {
                    return (
                      <PackageCard
                        data={entity}
                        onEditClick={this._onEdit}
                        currentUser={this.props.currentUser}
                        isCardClickEnable={true}
                        onDeleteClick={this._onDelete}
                        isDeleteEnable={true}
                        onCardClick={this._onCardClick}
                        isPackageCollection={true}
                      />
                    )
                  })}
              </div>
              {this.props.entityList && this.props.entityList.length > 0 && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    style={{
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                    onChange={this._onPageChange}
                    defaultCurrent={this.state.filters.currentPage}
                    total={this.props.total < 10000 ? this.props.total : 10000}
                    pageSize={this.state.filters.pageSize}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </Auxiliary>
        {this.state.showModal && this._modal()}
        {this.state.showEntityModal && this._showManageCollectionEntities()}
      </React.Fragment>
    )
  }
}

function mapStateToProps(store, ownProps) {
  return {
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
    total: _.get(store, "package.total"),
    common: _.get(store, "common"),
    isMobile: _.get(store, "common.isMobile"),
    loading: _.get(store, "package.loading"),
    entityList: _.get(store, "package.entities"),
    refetch: _.get(store, "package.refetchData"),
    currentUser: _.get(store, "currentUser.currentUser.data"),
  }
}

export default connect(mapStateToProps)(ManagePackageCollections)
